
import { defineComponent } from 'vue';
import { adService } from '../AdService';
import store from '@/store';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'AdListItemFavorite',
  props: {
    ad: {
      type: Object,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLoggedIn() {
      return store.getters['isLoggedIn'];
    },
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      isLoginModalVisible: false,
    };
  },
  methods: {
    showLoginModal() {
      this.isLoginModalVisible = true;
    },
    closeLoginModal() {
      this.isLoginModalVisible = false;
    },
    async favorite() {
      if (!this.isLoggedIn) {
        this.showLoginModal();
        return;
      }

      if (!this.ad) {
        return;
      }

      if (this.ad.isFavorite) {
        const result = await adService.removeFavorite(this.ad.adId);
        if (result.status === 200) {
          this.ad.isFavorite = false;
          store.dispatch('favoriteCount', result.data);
        }
      } else {
        const result = await adService.addFavorite(this.ad.adId);
        if (result.status === 200) {
          this.ad.isFavorite = true;
          store.dispatch('favoriteCount', result.data);
        }
      }
    },
  },
});
